import React, { useEffect, useState } from 'react';
import { DialogContent } from '@material-ui/core';
import { IUserSession } from '../../../../@types/employee';
import ProjectDialog from '../../../customComponentV2/dialog/ProjectDialog';
import { ICompanyFormValues } from '../../../../@types/model/masterData/company/CompanyFormValues';
import CompanyHelper, { ICompany } from '../../../../@types/model/masterData/company';
import CompanyEditForm from './CompanyForm';
import GeneralFunctions from '../../../../store/general/functions';

interface IValueAddedTaxEditDialogProps {
    currentUser ?: IUserSession | null;
    selectedCompany : ICompany | null;
    isOpen : boolean;
    onDismiss : () => void;
    companies : Array<ICompany>;
}

const CompanyEditDialog = (props : IValueAddedTaxEditDialogProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [entrySaved, setEntrySaved] = useState<boolean>(false);

    /*================================================================================================================
     *                                                      Effects
     * ==============================================================================================================*/

    useEffect(() => {
        if (entrySaved) {
            setEntrySaved(false);
            props.onDismiss();   
        } 

    }, [entrySaved]);

    /*================================================================================================================
    *                                                  Handler Methods
    * ==============================================================================================================*/

    const onSubmit = async (formValues : ICompanyFormValues) : Promise<void> => {
        setIsLoading(true);

        if (!props.currentUser) {
            setIsLoading(false);
            return;
        }
        
        const company = CompanyHelper.createSave(props.currentUser, formValues, props.selectedCompany);

        try {
            await CompanyHelper.save(company);
            setIsLoading(false);
            setEntrySaved(true);
            GeneralFunctions.generalShowSuccessSnackbar('Company updated successfully.');
        } catch (e) {
            GeneralFunctions.generalShowErrorSnackbar('An error occurred while saving Company.');
            setIsLoading(false);
        }
    };


    const getInitialFormValues = () : ICompanyFormValues => {
        return CompanyHelper.createFormValues(props.selectedCompany);
    };

    /*================================================================================================================
    *                                                  Memos
    * ==============================================================================================================*/

    /*================================================================================================================
    *                                                  Render
    * ==============================================================================================================*/

    return (
        <>
            <ProjectDialog
                title={props.selectedCompany ? 'Edit Company' : 'Add Company'}
                isOpen={props.isOpen}
                isLoadingCircular={isLoading}
                onClose={props.onDismiss}
                maxWidth={'sm'}>
                <DialogContent className='fdc flx1 jcfs hfill'>
                    <CompanyEditForm
                        initialValues={getInitialFormValues()} 
                        onSubmit={onSubmit} 
                        onCancel={props.onDismiss}
                    />
                </DialogContent>
            </ProjectDialog>
        </>
    );
};

export default CompanyEditDialog;